/** @format */

import styled from "styled-components";
import Spinner from "./spinner";

const Button = styled.button`
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 2.5em;
  background: #000000;
  opacity: ${(props) => (props.disabled ? "0.7" : "1")};
  border-radius: 0.8125em;
  margin: 0.625em 0;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: 0.625em auto;
    width: 100%;
  }
`;
interface ButtonProp {
  value: any;
  isloading: boolean;
  width?: string;
  isDisabled?: boolean;
}
const SubmitButton = ({ value, width, isloading, isDisabled }: ButtonProp) => {
  const submitValue: any = isloading ? (
    <div className="flex justify-center  text-[#ffffff] ...">
     <Spinner/>
      <span className="ml-2">Processing...</span>
    </div>
  ) : (
    value
  );

  return (
    <Button type="submit" disabled={isDisabled} className={width ? `w-[${width}]` : "w-[19.6em]"}>
      {submitValue}
    </Button>
  );
};

export default SubmitButton;
